// /*********************** Custom JS for Boost AI Search & Discovery  ************************/

const customize = {
  updateMetaInfo: (componentRegistry) => {
    componentRegistry.useComponentPlugin('ProductItem', {
      name: 'Modify Product Info',
      enabled: true,
      apply: () => ({
        afterRender(element){
          let data = element.getParams().props.product;
          let productItem = document.querySelector('[data-product-id="'+ data.variant_id +'"]');
          if (productItem == null) {
            productItem = document.querySelector('[data-product-id="'+ data.id +'"]');
          }
          if (productItem == null) {
            return;
          }

          if (data.original_title != undefined) {
            productItem.querySelector(".boost-sd__product-title").textContent = data.original_title;
          } else {
            productItem.querySelector(".boost-sd__product-title").textContent = data.title;
          }
          if (data.handle == 'gift-bag-xl') {
            console.log(data);
          }
          const comingBadges = data.tags.filter(function(e) {
            return e.indexOf('comingsoon') !== -1;
          })
          
          if (typeof comingBadges[0] !== 'undefined') {
            const tagValue = comingBadges[0].replace('comingsoon_', '');
            let d = new Date();
            let year    = d.getFullYear();
            let month   = d.getMonth() + 1;
            let day     = d.getDate();
            let hours   = d.getHours();
            let minutes = d.getMinutes();
            let dateStr = year + ("0"+month).slice(-2) + ("0"+day).slice(-2) + ("0"+hours).slice(-2) + ("0"+minutes).slice(-2);
            let fulldate = `${dateStr}`;
            if (parseInt(fulldate) <= parseInt(tagValue)) {
              console.log('id: ' + data.id + ' comingsoon: ' + tagValue);
              // SOLD OUTなど他のバッジがあった場合は消す
              const target = productItem.querySelector('.boost-sd__product-image-column--left');
              if (target) {
                target.innerHTML = '';
              }
              // COMING SOONのバッジ追加              
              const badgeHtml = document.createElement('div');
              badgeHtml.classList = 'boost-sd__product-label boost-sd__product-label--rectangle product-label--coming-badge';
              badgeHtml.style.cssText = 'color: #000; background-color:#fff; border: 1px solid #000';
              badgeHtml.innerHTML = '<span class="boost-sd__product-label-text"><span>COMING SOON</span></span>';
  
              productItem.querySelector('.boost-sd__product-image-column--left').appendChild(badgeHtml);
            }
          }
        }
      }),
    });
  },
  updateProductItemPrice: (componentRegistry) => {
    componentRegistry.useComponentPlugin('FormatCurrency', {
      name: 'Add tax to product price #208674',
      enabled: true,
      apply: () => ({
        afterRender(element){
          try {
          // Start customization--------------------------------------------
            const formatMoneyHelper = element.getHelpers().formatMoney;
            let value = element.getParams().props.value;

            value = value + value * 0.1;
            const customValue = formatMoneyHelper(Number(value),window.boostSDAppConfig?.shop?.money_format, true);
    
            element.getRootElm().querySelector('.boost-sd__format-currency span').innerHTML = customValue;
          // End-------------------------------------------------------------
          } catch (e) {
	          console.error(e) ;
          }
        }
      }),
    });
  }
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.updateMetaInfo]);
